import './InfoModal.css';

const InfoModal = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  return (
    <div className="info-modal-overlay" onClick={onClose}>
      <div className="info-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="info-modal-header">
          <h2>{title}</h2>
          <button className="info-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="info-modal-body">
          {content}
        </div>
        <div className="info-modal-footer">
          <button className="btn-close" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
